import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import { TextField, Button } from "@mui/material";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { createShortenUrl } from "./Helper";

const ShortenUrlUpdate = () => {
  const context = useOutletContext();
  const location = useLocation();
  const id = location.state?.id == null ? null : location?.state?.id;
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: {
      slug: location.state?.slug || "",
    },
  });

  useEffect(() => {
    context(["Shorten URL", id == null ? "Create Short URL" : "Update Short URL"]);
    if (location.state?.slug) {
      setValue("slug", location.state.slug);
    }
  }, []);

  const submit = (formData) => {
    if (id != null) {
      Swal.fire({
        icon: "info",
        title: "Update Not Available",
        text: "Update functionality is not available yet",
        confirmButtonColor: "#2EBAA3",
      });
      return;
    }

    setIsSubmitting(true);
    
    createShortenUrl({
      originalUrl: formData.slug,
      linkType: "none",
    })
      .then((response) => {
        setIsSubmitting(false);
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Short URL created successfully",
          confirmButtonColor: "#2EBAA3",
        }).then(() => {
          navigate("/ShortenUrl");
        });
      })
      .catch((error) => {
        setIsSubmitting(false);
        console.error("Error creating short URL:", error);
        const errorMessage = error.response?.data?.message || error.message || "Failed to create short URL";
        Swal.fire({
          icon: "error",
          title: "Error",
          text: errorMessage,
          confirmButtonColor: "#2EBAA3",
        });
      });
  };


  return (
    <div className="p-5 mx-auto w-[60%] mt-20 shadow-md bg-white">
      <div className="grid grid-cols-6 gap-2">
        <h3
          className="col-span-5 text-lg uppercase tracking-wider font-bold"
          style={{ color: "#2EBAA3" }}
        >
          {id == null ? "Create" : "Update"} Short URL
        </h3>
      </div>
      <br />
      <div class="overflow-x-auto relative ">
        <form onSubmit={handleSubmit((data) => submit(data))}>
          <div className="pt-2">
            <TextField
              className="w-full"
              id="outlined-basic"
              {...register("slug", { 
                required: "URL is required",
                pattern: {
                  value: /^https?:\/\/.+/,
                  message: "Please enter a valid URL starting with http:// or https://"
                }
              })}
              label="FULL URL *"
              margin="normal"
              variant="outlined"
              size="small"
              placeholder="https://www.example.com/very/long/url"
            />
            {errors.slug && (
              <p className="text-red-500 text-xs">{errors.slug.message}</p>
            )}
            <div className="mt-2 text-sm text-gray-500">
              Short URL will be generated automatically after creation
            </div>
          </div>
          <br />
          <div className="text-right pt-10">
            <Button
              type="button"
              variant="outlined"
              style={{ marginRight: "10px" }}
              onClick={() => navigate("/ShortenUrl")}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="contained"
              style={{ color: "white" }}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Processing..." : id == null ? "Create" : "Update"} Short URL
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ShortenUrlUpdate;

